/**
 *? USED ONLY in CashInfo project
 ** This locale contains all translations containing the original 'point de vente', renamed to 'point de vente'
 */
export const frRenamingCentersAsSalePoint = {
    'shops.list.pageTitle': 'Points de vente',
    'navbar.centers': 'Points de vente',
    'modules.list.filters.shop.label': 'Points de vente',

    //---MODULES

    //*PACKAGED ORDERS
    'packagedOrders.list.table.header.nbShops': 'Nb points de vente',
    'packagedOrders.list.table.filters.favoriteShops': 'Mes points de vente favoris',
    'packagedOrders.details.tabs.results.orderedShopCountValue':
        '{ordered_shop_count} points de vente / {shop_count}',
    'packagedOrders.details.tabs.results.tableHeader.shop': 'Points de vente',
    'packagedOrders.details.tabs.results.detailDialog.title': 'Commande du point de vente {name}',

    //*TUNNABLE OFFERS
    'tunableOffers.details.tabs.results.dialogTitle': 'Commande du point de vente',
    'tunableOffers.details.tabs.results.tableHeader.shop': 'Points de vente',

    //*OPERATIONS
    'operations.list.table.header.nbShops': 'Nb points de vente',

    //*VIDEOS
    'videos.list.table.header.nbShops': 'Nb points de vente',
    'videos.list.table.filters.favoriteShops': 'Mes points de vente favoris',

    //*SURVEYS
    'surveys.list.table.header.nbShops': 'Nb points de vente',
    'surveys.list.table.filters.favoriteShops': 'Mes points de vente favoris',
    'surveys.details.tabs.results.answersFrom': 'Réponse(s) du point de vente',
    'surveys.details.tabs.results.tableHeader.shop': 'Points de vente',

    //*EVENTS
    'events.list.table.header.nbShops': 'Nb points de vente',
    'events.list.table.filters.favoriteShops': 'Mes points de vente favoris',
    'events.details.tabs.results.answersFrom': 'Réponse(s) du point de vente',
    'events.details.tabs.results.tableHeader.shop': 'Points de vente',

    'events.results.dialog.title': 'Réponse(s) du point de vente {name}',

    //*CHALLENGES
    'challenges.list.table.header.nbShops': 'Nb points de vente',
    'challenges.score.import.tab.shops': 'Nb points de vente',
    'challenges.notification.history.table.header.shops': 'Nb points de vente',

    //*COLLECTIONS
    'collections.list.table.header.nbShops': 'Nb points de vente',

    //*QUIZZ
    'quizzes.list.table.header.nbShops': 'Nb points de vente',
    'quizzes.details.results.filters.shop.label': 'Points de vente',
    'quizzes.details.results.tableHeader.shop': 'Points de vente',

    //*AUDIENCES
    'audiences.filters.audience.favorite': 'Audience : Points de vente favoris',
    'modules.content.audiences.broadcastAudience': 'Tous les points de vente',

    //---ADMIN MODULES

    //*TEAMS
    'teams.create.tabs.favorites': 'Points de vente Favoris',

    //*SECTORS
    'sectors.details.sectionTitle': 'LISTE POINT DE VENTES ENFANTS',

    '.details.sectionTitle': 'LISTE POINT DE VENTES ENFANTS',
    'sectors.details.detailsInfo':
        'Pas de point de vente enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Points de vente » où vous pourrez affecter des secteurs parents.',
    'sectors.details.actions.disabledRemoveInfo':
        'Ce point de vente contient des points de vente et ne peut être supprimée.',
    'sectors.create.sectionTitle': 'LISTE POINT DE VENTES ENFANTS',
    'sectors.create.createInfo':
        'Pas de point de vente enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Points de vente » où vous pourrez affecter des secteurs parents.',

    //*SHOPS
    'shops.details.pageTitle': 'Détails point de vente',
    'shops.create.pageTitle': 'Création point de vente',

    'shops.title': 'Points de vente',
    'shops.list.sectionTitle': 'Points de vente',
    'shops.list.emptyLabel': 'Aucun point de vente pour le moment.',
    'shops.list.actions.addShop': 'Ajouter un point de vente',
    'shops.filters.shopTypeFilter.name': 'Type de point de vente',
    'shops.filters.shopTypeFilter.filterLabelName': 'Type de point de vente: {type}',
    'shops.details.detailsInfo':
        'Pas de point de vente enfant pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Points de vente » où vous pourrez affecter des secteurs parents.',
    'shops.details.actions.removeShop': 'Supprimer le point de vente',
    'shops.details.actions.previous': 'Points de vente',
    'shops.details.dialog.title': 'Suppression de point de vente',
    'shops.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce point de vente ?',
    'shops.details.input.name': 'Saisissez ici le nom du Points de vente *',
    'shops.details.input.code': 'Saisissez ici le code du Points de vente *',
    'shops.details.select.user.floatingLabel': 'Responsable point de vente :',
    'shops.details.toggle.invisible.label': 'Points de vente invisible ?',
    'shops.details.roles.manager': 'Responsable de point de vente',
    'shops.create.select.user.floatingLabel': 'Responsable point de vente :',
    'shops.create.input.name': 'Saisissez ici le nom du Points de vente *',
    'shops.create.input.code': 'Saisissez ici le code du Points de vente *',

    'shops.import.success': 'Bravo! Points de vente importés avec succès',

    'shops.list.item.floatingLabelParentName': 'Point de vente',
    'shops.details.select.parent.floatingLabel': 'Point de vente parent :',
    'shops.details.select.parent.title': 'Choisir un point de vente parent *',
    'shops.details.select.parent.listTitle': 'Choix du point de vente parent',
    'shops.details.select.parent.listInputLabel': 'Chercher un point de vente',

    'shops.details.roles.Manager': 'Responsable de point de vente',

    //* AUDITS
    'audits.analysis.shop.title': 'Comparatif points de vente',
    'audits.analysis.shop.category.title': '{nb} Points de vente',
    'audits.analysis.shop.category.singular.title': '{nb} Point de vente',
    'audits.analysis.shop.category.title.missing': 'Non audités ({nb} Points de vente)',
    'audits.analysis.shop.category.title.missing.singular': 'Non audités ({nb} Point de vente)',
    'audits.analysis.region.question.subtitle': 'Point de vente :',
    'audits.analysis.theme.shop.title': 'Comparatif points de vente',
    'audits.analysis.theme.shop.table.header.shop': 'Point de vente',
    'audits.analysis.comments.modal.region.shop': 'Point de vente :',

    //*BACK USERS
    'backofficeUsers.list.othersLabel': 'autres points de vente',
    'backofficeUsers.create.tabs.favShops': 'Points de vente favoris',
    'backofficeUsers.create.tabs.groupLeaderShops': 'POINT DE VENTES ANIMÉS',
    'backofficeUsers.create.tabs.permissions.toggles.shopsread': 'Lire les points de vente',
    'backofficeUsers.create.tabs.permissions.toggles.shopswrite': 'Éditer les points de vente',
    'backofficeUsers.details.actions.disabledRemoveInfo':
        'Cet utilisateur siège possède des points de vente et ne peut être supprimé.',
    'backofficeUsers.details.tabs.favShops': 'Points de vente favoris',
    'backofficeUsers.create.tabs.groupLeaderShops.treeTitle': 'POINT DE VENTES ANIMÉS',

    //*USERS
    'users.list.othersLabel': 'autres points de vente',
    'users.create.sectionTitle': 'Points de vente',
    'users.create.createInfo':
        'Pas de points de vente pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Points de vente » où vous pourrez affecter le collaborateur à des points de vente.',
    'users.details.centersTitle': 'LISTE POINT DE VENTES',
    'users.details.detailsInfo':
        'Pas de points de vente pour le moment. Pour en ajouter, rendez-vous dans l’onglet « Points de vente » où vous pourrez affecter le collaborateur à des points de vente.',
    'users.details.actions.disabledRemoveInfo':
        'Ce collaborateur possède des points de vente et ne peut être supprimé.',
    'collaboratorRoles.shops.role.title': 'Liste points de vente en tant que {role}',

    //* TAGS
    'tags.audiences.addTagTitle':
        'Ajouter des points de vente à l’audience en cliquant sur les tags correspondants au critère voulu :',
    'tags.audiences.tagAdded.content': '{count} points de vente(s) ajouté(s) à l’audience.',
    'tags.audiences.tagsAlreadyInAdded.content':
        'Le(s) points de vente(s) sont déjà dans l’audience.',

    //*ERRORS
    'toast.apiErrors.FRONT_USER_HAVE_SHOPS':
        'Cet utilisateur est associé à des points de vente, il ne peut pas être supprimé',
};
